import React, { useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { addEmployeeSlice, addEmployeeState } from './AddModalSlice'
import { employeesSlice } from '../EmployeesSlice'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField, NumberField, SelectField } from '../../../components/FormElements/FormElements'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'

import { useAPI } from '../../../services/hoc/useAPI'

export default () => {
    
    // Translation
    const t = useTranslation()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector( ( state: { add_employee: addEmployeeState } ) => state.add_employee )
const ENDPOINTS = useAPI()
    // Hooks
    const [ showErrors, setShowErrors ] = useState<boolean>(false)

    // Working status options
    const working_status_options = [
        { value: "Working", label: t("working") },
        { value: "Pending", label: t("pending") },
        { value: "Suspended", label: t("suspended") }
    ]

    // Add employee
    const add = ( e: React.FormEvent<HTMLFormElement> ) => {
        
        e.preventDefault()

        if( state.fields.name === "" || state.fields.serial_no === "" || state.fields.mobile === "" || state.fields.job === "" || state.fields.salary === 0 || !state.fields.working_status ) {
            setShowErrors(true)
            return
        }

        dispatch( addEmployeeSlice.actions.setIsLoading(true) )
        const endpoint = state.editId ? ENDPOINTS.employees().update : ENDPOINTS.employees().store
        endpoint({ id: state.editId, name: state.fields.name || "", 
        serial_no: state.fields.serial_no || "", mobile: state.fields.mobile || ""
        , job: state.fields.job || "", salary: state.fields.salary || 0
        , working_status: state.fields.working_status })
        .then((response: any) => {
            dispatch( addEmployeeSlice.actions.setIsSuccess(true) )
            setTimeout(() => {
                toggle()
                state.editId? dispatch( employeesSlice.actions.updateEmployee(response.data.data)):
                dispatch(employeesSlice.actions.addEmployees([response.data.data]))
            }, 1000);
        })

    }

    const toggle = () => {
        dispatch( addEmployeeSlice.actions.setIsOpen(!state.isOpen) )
        dispatch( addEmployeeSlice.actions.init() )
    }

    return(
        <Modal open={state.isOpen} toggle={toggle}>

            { state.isLoading ? <WhiteboxLoader /> : ""}

            { state.isSuccess ? <SuccessMark /> : ""}
            
            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{ state.editId ? t("edit_employee") : t("add_to_employees")}</h2>

            <form onSubmit={add} style={{ width: 400, maxWidth: "100%" }}>

                <InputField
                    label={t("name") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addEmployeeSlice.actions.set({ name: e.target.value }))}
                    value={state.fields.name}
                    error={(showErrors && state.fields.name === "") ? t("required_error") : ""}
                />

                <InputField
                    label={t("serial_no") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addEmployeeSlice.actions.set({ serial_no: e.target.value }))}
                    value={state.fields.serial_no}
                    error={(showErrors && state.fields.serial_no === "") ? t("required_error") : ""}
                />

                <InputField
                    label={t("mobile") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addEmployeeSlice.actions.set({ mobile: e.target.value }))}
                    value={state.fields.mobile}
                    error={(showErrors && state.fields.mobile === "") ? t("required_error") : ""}
                />

                <InputField
                    label={t("job") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addEmployeeSlice.actions.set({ job: e.target.value }))}
                    value={state.fields.job}
                    error={(showErrors && state.fields.job === "") ? t("required_error") : ""}
                />

                <NumberField
                    label={t("salary") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addEmployeeSlice.actions.set({ salary: Number(e.target.value) }))}
                    value={state.fields.salary}
                    error={(showErrors && state.fields.salary === 0) ? t("required_error") : ""}
                />

                <SelectField
                    menuPlacement="top"
                    placeholder={t("is_working")}
                    options={working_status_options}
                    onChange={(selected: { value: 'Pending' | 'Working' |'Suspended' }) => dispatch(addEmployeeSlice.actions.set({ working_status: selected.value }))}
                    value={working_status_options.find(option => option.value === state.fields.working_status)}
                    error={(showErrors && !state.fields.working_status) ? t("required_error") : ""}
                />

                <button className="button round bg-gold color-white margin-top-30" style={{ padding: "0 80px", marginBottom: 5 }}>{t("submit")}</button>

            </form>

        </Modal>
    )

}